export default {
	title: 'addon_sensors',
	components: [{ title: 'addon_enable', component: 'addon_enable' }],
};

export const sensor_addon = [
	{
		addon: 'sensor',
	},
];

export const addon_pro_lora_devices = [
	{
		addon: 'LoRa',
		min_ver: '2.0.0',
	},
];

// Compatible PRO devices:
// Shelly Pro 1
// Shelly Pro 2
// Shelly Pro 1PM
// Shelly Pro 2PM
// Shelly Pro Dimmer 1PM
// Shelly Pro Dimmer 2PM
// Shelly Pro EM - 50
// Shelly Pro 3EM
// Shelly Pro Dimmer 0 / 1–10V PM

export const addon_pro_devices = [
	...addon_pro_lora_devices,
	{
		addon: 'sensor',
		addonType: 'prosensor',
		min_ver: '2.0.0',
	},
	{
		addon: 'RS485',
		addonType: 'proRS485',
		min_ver: '2.0.0',
	},
];

export const addon_pro_em_devices = [
	...addon_pro_devices,
	{
		addon: 'prooutput',
	},
];

export const addon_plus_devices_g2 = [...sensor_addon];

export const addon_plus_devices_g3 = [
	{
		addon: 'LoRa',
		min_ver: '1.5.99',
	},
	...sensor_addon,
];
